import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { formatDate } from "@/lib/data";

export default function Customers() {
  const { data: customers = [] } = useQuery({ queryKey: ["partner-customers"], queryFn: () => get("/partner/customers") });

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Müşteriler</h1>
      <p className="text-sm text-[#64748B]">Stüdyonuzda rezervasyon yapan müşteriler</p>

      <div className="mt-5 overflow-hidden rounded-md border border-[#E2E8F0] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#F1F5F9] text-left text-xs uppercase tracking-wide text-[#64748B]">
            <tr>
              <th className="px-4 py-3">Müşteri</th>
              <th className="px-4 py-3">Ziyaret</th>
              <th className="px-4 py-3">Harcanan kredi</th>
              <th className="px-4 py-3">Son ziyaret</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {customers.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-[#64748B]">Müşteri kaydı yok.</td></tr>}
            {customers.map((c, i) => (
              <tr key={i} data-testid={`customer-row-${i}`} className="hover:bg-[#F7F9FA]">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#E2E8F0] text-xs font-semibold">{c.name.charAt(0)}</div>
                    <span className="font-medium">{c.name}</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-[#475569]">{c.visits}</td>
                <td className="px-4 py-3 text-[#475569]">{c.spent} kredi</td>
                <td className="px-4 py-3 text-[#475569]">{c.last ? formatDate(c.last) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
